import React, { useState } from "react";
import { SettingsPageLayout } from "newui/features/Settings/components/SettingsPageLayout";
import type { TabMenuItem } from "newui/components/TabComponent/TabComponent";
import type { Company } from "newui/features/Company/types";
import { ScoringInstructions } from "./components/ScoringInstructions/ScoringInstructions";
import { EvaluationPermissions } from "./components/EvaluationPermissions/EvaluationPermissions";

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

interface RfxSettingsProps {
  company: Company;
  path?: string;
}

/* -------------------------------------------------------------------------- */
/* Constants                                                                  */
/* -------------------------------------------------------------------------- */

const SCORING_INSTRUCTIONS = "Scoring Instructions";
const EVALUATION_PERMISSIONS = "Evaluation Permissions";

const TAB_MENU: TabMenuItem[] = [
  {
    id: "scoring-instructions",
    name: SCORING_INSTRUCTIONS,
    showBadge: false,
    total: 0,
  },
  {
    id: "evaluation-permissions",
    name: EVALUATION_PERMISSIONS,
    showBadge: false,
    total: 0,
  },
];

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export const RfxSettings: React.FC<RfxSettingsProps> = ({ company }) => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const tab = params.get("tab");

  const [currentTab, setCurrentTab] = useState<string>(tab || SCORING_INSTRUCTIONS);

  const changeActiveTab = (name: string, _id: string): void => {
    setCurrentTab(name);
  };

  return (
    <SettingsPageLayout
      heading="RFx Settings"
      tabs={TAB_MENU}
      activeTab={currentTab}
      onTabChange={changeActiveTab}
    >
      {currentTab === SCORING_INSTRUCTIONS && (
        <ScoringInstructions company={company} />
      )}
      {currentTab === EVALUATION_PERMISSIONS && (
        <EvaluationPermissions company={company} />
      )}
    </SettingsPageLayout>
  );
};
